import {Idiomas} from "./idiomas";

export class IdiomasMenu extends Idiomas {
    public visible = false;
    constructor(_cod: string, _nombre: string) {
        super(_cod, _nombre);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/dominio/idiomas/idiomasMenu.ts